import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { ConcatInquiryContainer } from '../containers/ConcatInquiryContainer';
import { ContactSellerInfoContainer } from '../containers/ContactSellerInfoContainer';
import { PolicyListContainer } from '../containers/PolicyListContainer';
import { PolicyResponsibilityContainer } from '../containers/PolicyResponsibilityContainer';
import { ProductInfoProvidedNoticeContainer } from '../containers/ProductInfoProvidedNoticeContainer';
import { SellerContact } from './SellerContact';

interface Props extends React.HTMLProps<HTMLDivElement> {
  isInApp: boolean;
  isMobile: boolean;
  contactData: {
    customer_center_tel: string | null;
    manager_name: string | null | undefined;
    manager_tel: string | null | undefined;
    business_hours: string[];
    company_email: string | null | undefined;
  };
}
export const Contact: React.FC<React.PropsWithChildren<Props>> = ({ className, isInApp, isMobile, contactData }) => {
  return (
    <Container className={className}>
      <ConcatInquiryContainer />
      <SellerContact isInApp={isInApp} isMobile={isMobile} contactData={contactData} />
      <Divider />
      <ContactSellerInfoContainer />
      <Divider />
      <ProductInfoProvidedNoticeContainer />
      <PolicyListContainer />
      <PolicyResponsibilityContainer />
    </Container>
  );
};

const Container = styled.div`
  background-color: ${vars.v3Color.staticWhite};
`;

const Divider = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${vars.v3Color.gray100};
`;
